import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import Frame from "../../assets/images/ramka.png"

const Frame_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={Frame} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-width">
        <h2 className="spec-title">{t('accessoires.frame.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.frame.details.p1')}</li>
          <li>{t('accessoires.frame.details.p2')}</li>
          <li>{t('accessoires.frame.details.p3')}</li>
        </ul>
      </div>

    </div>
  );
};

export default Frame_SPEC;
